/*
 *             Copyright (c) 2016 - 2021, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x305a=['mapper','mapViewToDom','name','domConverter','values'];(function(_0x3eddab,_0x305a87){const _0x598ba5=function(_0x327cfc){while(--_0x327cfc){_0x3eddab['push'](_0x3eddab['shift']());}};_0x598ba5(++_0x305a87);}(_0x305a,0x16c));const _0x598b=function(_0x3eddab,_0x305a87){_0x3eddab=_0x3eddab-0x0;let _0x598ba5=_0x305a[_0x3eddab];return _0x598ba5;};import _0x51d431 from'@ckeditor/ckeditor5-utils/src/first';export default function M(_0x1d714d,_0x22cae7){const _0x4020cd=_0x1d714d[_0x598b('0x1')]['markerNameToElements'](_0x22cae7[_0x598b('0x3')]),_0x9627df=_0x51d431(_0x4020cd[_0x598b('0x0')]());return _0x1d714d['view'][_0x598b('0x4')][_0x598b('0x2')](_0x9627df);}